<template>
  <div>
    <component :is="layoutComponentName">
      <router-view />
    </component>
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import DashboardLayout from "@/common/ui/layout/DashboardLayout";
import useUserProfile from "@/common/hooks/useUserProfile.js";
import refreshAuthorizationHeader from "@/common/axios";

export default {
  name: "App",
  components: {
    DefaultLayout,
    DashboardLayout,
  },

  setup() {
    const { loadUserProfile } = useUserProfile();
    loadUserProfile();
    return {};
  },
  computed: {
    layoutComponentName() {
      return this.$route.meta?.layout || "DashboardLayout";
    },
    userLoaded() {      
      return this.$store.state.auth?.oidc?.user != null && localStorage.getItem('token');
    }
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("auth/oidc/loadUser");
  },
  watch: {
    userLoaded: function(value) {
      if (value) {
        console.log('userLoaded');
        refreshAuthorizationHeader();
        const { loadUserProfile } = useUserProfile();
        loadUserProfile();
      }
    }
  }
};
</script>
